import { DialogService } from "@/service/DialogService";
import { SyuugyouJoukenMeijisyoService } from "@/service/SyuugyouJoukenMeijisyoService";
import { SyuugyouJoukenMeijisyo } from "@/types/SyuugyouJoukenMeijisyo"
import { cloneDeep } from "lodash";
import { ref, Ref } from "vue"

export function useSyuugyouJoukenMeijisyoInit() {
  const koyouKeiyakuId: Ref<number | null> = ref(null)
  const meijisyo: Ref<SyuugyouJoukenMeijisyo | null> = ref(null);
  const editingMeijisyo: Ref<SyuugyouJoukenMeijisyo | null> = ref(null);
  const srv = new SyuugyouJoukenMeijisyoService()
  const isEditing = ref(false)

  const findByKoyouKeiyakuId = async () => {
    if (!koyouKeiyakuId.value) {
      return
    }

    const res = await srv.findByKoyouKeiyakuId(koyouKeiyakuId.value);
    if (res.meijisyo) {
      meijisyo.value = res.meijisyo
    }
  }

  const createMeijisyo = async () => {
    if (!meijisyo.value) {
      return
    }
    await srv.create(meijisyo.value)
  }

  const updateMeijisyo = async () => {
    if (!meijisyo.value) {
      return
    }

    await srv.update(meijisyo.value)
  }

  const initMeijisyo = async () => {
    if (meijisyo.value) {
      DialogService.error({
        title: '初期化エラー',
        text: 'すでに初期化されています',
      })
      return
    }

    if (meijisyo.value) {
      DialogService.error({
        title: '初期化エラー',
        text: '雇用契約IDが指定されていません',
      })
      return
    }

    meijisyo.value = new SyuugyouJoukenMeijisyo()
    meijisyo.value.koyou_keiyaku_id = koyouKeiyakuId.value
  }

  const startEditMode = async () => {
    isEditing.value = true;
    editingMeijisyo.value = cloneDeep(meijisyo.value)
  }
  const endEditMode = async () => {
    isEditing.value = false
    editingMeijisyo.value = null
    await findByKoyouKeiyakuId()
  }

  return {
    koyouKeiyakuId,
    meijisyo,
    findByKoyouKeiyakuId,
    createMeijisyo,
    updateMeijisyo,
    initMeijisyo,
    isEditing,
    startEditMode,
    endEditMode
  }
}